import React,{useState} from 'react'
import { KTSVG } from '../../helpers/KTSVG'
import { KTIcon } from '../../helpers'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import { toAbsoluteUrl } from '../../helpers'
import clsx from 'clsx'
import EcxOffcanvas from './EcxOffcanvas'
import { Link } from 'react-router-dom'
function EcxHeader() {
 
    const sidebarBroken = useEyeconxStore((state)=>state.sidebarBroken)
    const toggleSidebar= useEyeconxStore((state)=>state.toggleSidebar)
    const user = useEyeconxStore((state)=>state.user)

    const [userSidebar,setUserSidebar] = useState(false)

    const handleClose = ()=>{
        setUserSidebar(!userSidebar)
    }
  return (
    <div 
   
    className={clsx("d-flex align-items-center justify-content-between p-5 w-100 h-100",sidebarBroken && 'bg-dark')}>
        <div>
            {sidebarBroken?<>
                <button className="btn btn-custom " onClick={toggleSidebar}>
                    <KTSVG path="media/icons/duotune/layouts/lay004.svg" className='svg-icon-1'/>
                </button>
            </> :<div>
                    
                   <Link to="articles" className="btn btn-bg-light btn-color-dark btn-sm me-2"><i className="bi bi-book"></i> Articles</Link>
                   <Link to="eye-draw" className="btn btn-bg-light btn-color-dark btn-sm  me-2"><i className="bi bi-easel"></i> Eye Draw</Link>
                   <Link to="messages" className="btn btn-bg-light btn-color-dark btn-sm  me-2"><i className="bi bi-chat-right-text"></i> Messages</Link>
                </div>}
        </div>
        <div>
            {sidebarBroken?<>
                <img src={toAbsoluteUrl("media/logos2/logo-light.png")} alt="" />
            </> :""}

        </div>
        <div>
            {sidebarBroken?<>
                <button className="btn btn-custom " onClick={handleClose}>
                <KTSVG path="media/icons/duotune/coding/cod001.svg" className="svg-icon-1"/>
                </button>
            </> :
            <ul className="nav align-items-center">
                <li className="nav-item ms-1 ms-md-4">
                    <div className="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px">
                         <KTIcon iconName='magnifier' className='fs-2' />
                    </div>
                </li>
                <li className="nav-item ms-1 ms-md-4">
                     <div className="btn btn-custom btn-active-light btn-active-color-primary" onClick={handleClose}>
                        Hi, {user&& user.name}  <KTSVG path="media/icons/duotune/coding/cod001.svg" className="svg-icon-2"/>
                     </div>
                </li>
            </ul>
            }
           
            <EcxOffcanvas show={userSidebar}  handleClose={handleClose}/>
        </div>
    </div>
  )
}

export default EcxHeader